export default __webpack_public_path__ + "img/pin_icons/escalator_w.svg";